import { render, staticRenderFns } from "./AButton.vue?vue&type=template&id=756ffc2a&scoped=true"
import script from "./AButton.vue?vue&type=script&lang=ts"
export * from "./AButton.vue?vue&type=script&lang=ts"
import style0 from "./AButton.vue?vue&type=style&index=0&id=756ffc2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756ffc2a",
  null
  
)

export default component.exports